import React from "react";

import { Company, Person } from "@mapmycustomers/shared/types/entity";
import { TextField, TextFieldProps } from "@mapmycustomers/ui";

import EmailButton from "@app/component/preview/components/Contacts/EmailButton";
import { EMAIL_REGEX } from "@app/util/regexp";

interface Props extends TextFieldProps {
  company?: Company;
  person?: Person;
}

const EmailTextFieldWithActions: React.FC<Props> = ({ company, person, ...props }) => {
  const value = props.value ? String(props.value) : "";
  const isValidEmail = EMAIL_REGEX.test(value);

  return (
    <TextField
      {...props}
      locked={props.disabled}
      suffix={
        isValidEmail ? (
          <EmailButton company={company} email={value} person={person} />
        ) : (
          // we need this span to occupy space in textfield's suffix icon place
          // because if it's not pre-occupied, input will lose its focus when a
          // EmailButton is added. Because it dramatically changes text field's
          // html layout.
          <span />
        )
      }
    />
  );
};

export default EmailTextFieldWithActions;
